import type { PortableTextComponents } from "@portabletext/svelte";
import Image from "./Image.svelte";
import YouTubeEmbed from "./YouTubeThumbnailLink.svelte";
import InlineReference from "./InlineReference.svelte";
import SourceReference from "./SourceReference.svelte";
import TextHighlighted from "./TextHighlighted.svelte";
import ChecklistWrapper from "./ChecklistWrapper.svelte";
import Link from "./Link.svelte";
import TextColor from "./TextColor.svelte";
import ColumnLayout from "./ColumnLayout.svelte";
import Table from "./Table.svelte";
import DetailsSummary from "./DetailsSummary.svelte";
import BlockQuote from "./BlockQuote.svelte";
import TypeformEmbed from "./TypeformEmbed.svelte";

export function createContentBlockComponents(
	overrides?: Partial<PortableTextComponents>,
): Partial<PortableTextComponents> {
	return {
		types: {
			image: Image,
			youtube: YouTubeEmbed,
			productReference: InlineReference,
			articleReference: InlineReference,
			fileReference: InlineReference,
			sourceReference: SourceReference,
			columns: ColumnLayout,
			table: Table,
			detailsSummary: DetailsSummary,
			typeformEmbed: TypeformEmbed,
			...overrides?.types,
		},
		block: {
			blockquote: BlockQuote,
			...(overrides?.block as Record<string, unknown>),
		} as unknown as PortableTextComponents["block"],
		marks: {
			link: Link,
			highlight: TextHighlighted,
			color: TextColor,
			...overrides?.marks,
		},
		list: {
			bullet: undefined,
			number: undefined,
			check: ChecklistWrapper,
			...(overrides?.list as Record<string, unknown>),
		} as unknown as PortableTextComponents["list"],
	};
}

export const contentBlockComponents = createContentBlockComponents();
